import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/505.svg")